import { render, staticRenderFns } from "./DraggableZone.vue?vue&type=template&id=42b91174&scoped=true&"
import script from "./DraggableZone.vue?vue&type=script&lang=ts&"
export * from "./DraggableZone.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableZone.vue?vue&type=style&index=0&id=42b91174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b91174",
  null
  
)

export default component.exports